// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IRAWKFLXB1Aw6WdA0E4Q{background:var(--background-neutral-subtle);--titled-row-action-width:120px;border-radius:8px;flex-direction:column;gap:13.5px;padding:20px 16px;display:flex;position:relative}.TxetDVQP0AMieGyBpirH{background-color:rgba(255,255,255,.5);display:none;position:absolute;top:0;bottom:0;left:0;right:0}.chCcubsD5mABOAFFAFId{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `IRAWKFLXB1Aw6WdA0E4Q`,
	"loading": `TxetDVQP0AMieGyBpirH`,
	"active": `chCcubsD5mABOAFFAFId`
};
export default ___CSS_LOADER_EXPORT___;
